
function roundToOne(num){
  return +(Math.round(num + "e+1")  + "e-1");
}

function volumeOfT(p1, p2, p3){
  let v321 = p3.x*p2.y*p1.z;
  let v231 = p2.x*p3.y*p1.z;
  let v312 = p3.x*p1.y*p2.z;
  let v132 = p1.x*p3.y*p2.z;
  let v213 = p2.x*p1.y*p3.z;
  let v123 = p1.x*p2.y*p3.z;
  return (-v321 + v231 + v312 - v132 - v213 + v123)/6.0;
}

function calculateVolume(bufferGeometry){
  let volumes = 0.0;
  let geometry = new THREE.Geometry().fromBufferGeometry( bufferGeometry );
  let Pi= 0, Qi=0, Ri=0;
  let P=null, Q=null, R=null;
  for(let i = 0; i < geometry.faces.length; i++){
    Pi = geometry.faces[i].a;
    Qi = geometry.faces[i].b;
    Ri = geometry.faces[i].c;

    P = new THREE.Vector3(geometry.vertices[Pi].x, geometry.vertices[Pi].y, geometry.vertices[Pi].z);
    Q = new THREE.Vector3(geometry.vertices[Qi].x, geometry.vertices[Qi].y, geometry.vertices[Qi].z);
    R = new THREE.Vector3(geometry.vertices[Ri].x, geometry.vertices[Ri].y, geometry.vertices[Ri].z);
    volumes += volumeOfT(P, Q, R);
  }
  return Math.abs(volumes);
}

function calculateDimensions(_object) {
  var absoluteMinX = 0, absoluteMaxX = 0, absoluteMinY = 0, absoluteMaxY = 0, absoluteMinZ = 0, absoluteMaxZ = 0;

  for (var i = 0; i < _object.children.length; i++) {
    _object.children[i].geometry.computeBoundingBox();
    absoluteMinX = Math.min(absoluteMinX,_object.children[i].geometry.boundingBox.min.x);
    absoluteMaxX = Math.max(absoluteMaxX,_object.children[i].geometry.boundingBox.max.x);
    absoluteMinY = Math.min(absoluteMinY,_object.children[i].geometry.boundingBox.min.y);
    absoluteMaxY = Math.max(absoluteMaxY,_object.children[i].geometry.boundingBox.max.y);
    absoluteMinZ = Math.min(absoluteMinZ,_object.children[i].geometry.boundingBox.min.z);
    absoluteMaxZ = Math.max(absoluteMaxZ,_object.children[i].geometry.boundingBox.max.z);
  }

  // set generic height and width values
  _object.depth = (absoluteMaxX - absoluteMinX) * _object.scale.x;
  _object.height = (absoluteMaxY - absoluteMinY) * _object.scale.y;
  _object.width = (absoluteMaxZ - absoluteMinZ) * _object.scale.z;

  // remember the original dimensions
  if (_object.originalDepth === undefined) _object.originalDepth = _object.depth;
  if (_object.originalHeight === undefined) _object.originalHeight = _object.height;
  if (_object.originalWidth === undefined) _object.originalWidth = _object.width;
  return new THREE.Vector3(_object.depth, _object.height, _object.width);
}

function checkDefaultOption(){
  let defaultInput = $(".wg_options_default .swatch-value-container input[type='number']");
  let swatchSelectInput = $(".wg_options_default .swatch-option .swatch-value-container");
  let swatchSelectOptionInput = $(".wg_options_default .swatch-select option[value='Default']");
  if(defaultInput.length){
    if(defaultInput.prop("disabled")){
      defaultInput.prop("disabled", false).trigger('change');
    }
    if(!swatchSelectInput.hasClass("swatch-selected")){
      swatchSelectInput.toggleClass("swatch-selected", true).trigger('change'); 
      swatchSelectOptionInput.prop('selected', true).trigger('change');
    }
  }
  //let defaultInput = $("wg_options_price.wg_options_default .swatch-selected input[type='number']");
  return defaultInput;
}

function updateUnit(pVolumes, pSize){
  let scale = 1;
  if($(".wg_options_unit select.swatch-select option:selected").attr("value") == 'in'){
    scale = 25.4;
  }
  else if($(".wg_options_unit select.swatch-select option:selected").attr("value") == 'cm'){
    scale = 10;
  }
  let defaultInput = checkDefaultOption();
  if(defaultInput.length){
    let unitQty = Math.round(scale*scale*scale*pVolumes/1.75/60);
    let baseQty = unitQty - 500;
    if(baseQty > 0){
      unitQty = 500 + Math.round(0.3*baseQty);
    }
    let minQty = 50, maxQty = 200000;
    if(unitQty < minQty){
      unitQty = minQty;
    }
    else if(unitQty > maxQty){
      unitQty = maxQty;
    }
    defaultInput.val(unitQty).trigger('change');
  }
  let d_width = roundToOne(Math.abs(pSize.x));
  let d_length = roundToOne(Math.abs(pSize.y));
  let d_height = roundToOne(Math.abs(pSize.z));
  $(".wg_options").html('Bounding Box: ' + d_width + ' x '  + d_length + ' x ' + d_height);
  let max_width = 290, max_length = 290, max_height = 290;
  if(d_width*scale > max_width || d_length*scale > max_length || d_height*scale > max_height){
    alert("Maximum size we can process is " 
          + max_width + "mm × " 
          + max_length + "mm × " 
          + max_height + "mm.\nPlease scale your model and upload it again.");
  }
}

function addModalThumbnail(imageData, isTHREE=false){
  $("#wg_filethumbnail").html('<div><a href="#wg_modalviewer" rel="modal:open"><div>preview</div><img class="wg_modalimage wg_modalthumbnail" /></a></div>');
  if(!isTHREE){
    $("#wg_modalviewer").html('<img class="wg_modalimage" />');
  }
  $(".wg_modalimage").attr('src', imageData);
}

function addModalThumbnailCanvas(canvas){
  $("#wg_filethumbnail").html('<div><a href="#wg_modalviewer" rel="modal:open"><div>preview</div><div class="wg_modalimage wg_modalthumbnail"></div></a></div>');
  $(".wg_modalimage").append(canvas);
}
